import { motion } from 'framer-motion';
import styled from 'styled-components';

export const Container = styled.div`
  background-color: var(--color-primary);
  width: 100vw;
  height: 100vh;
  display: flex;
  margin: auto;

  @media (max-width: 768px) {
    display: block;
    background-color: #fff;
  }
`;

export const Left = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;

  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      margin-top: 5rem;
      width: 300px;
    }
  }
  .theo {
    margin: auto;
    img {
      border-radius: 50%;
      width: 500px;
      align-self: center;
    }
    h1 {
      text-align: center;
      font-size: 48px;
      font-weight: 700;
      color: #ffff;
    }
  }
  @media (max-width: 1024px) {
    .header {
      width: 100%;
      img {
        width: 300px;
      }
    }
    div {
      img {
        width: 350px;
      }
      h1 {
        font-size: 36px;
      }
    }
  }
  @media (max-width: 768px) {
    width: 100%;
    padding: 2rem;

    .header {
      width: 100%;
      display: flex;
      justify-content: center;
      img {
        width: 150px;
        align-self: center;
      }
    }
    div {
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 250px;
        align-self: center;
      }
      h1 {
        text-align: center;
        font-size: 28px;
        font-weight: 700;
        color: var(--color-secondary);
      }
    }
  }
`;

export const FormContainer = styled(motion.div)`
  overflow: hidden;
  background-color: #fff;
  clip-path: ellipse(70% 80% at 70% 50%);
  width: 100%;
  padding-left: 10rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    font-weight: 700;
    color: var(--color-primary);
    margin-bottom: 1rem;
  }

  button {
    border: 0;
    cursor: pointer;
    width: 350px;
    height: 60px;
    background: var(--color-primary);
    border-radius: 10px;
    color: #fff;
    font-weight: 600;
    font-size: 18px;
    text-align: center;
  }
  a {
    margin-top: 2rem;
    span {
      cursor: pointer;
      font-size: 18px;
      font-weight: 700;
      color: #a6a6a6;
    }
  }
  @media (max-width: 769px) {
    clip-path: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem 0;
    background-color: transparent;
    h1 {
      font-weight: 700;
      color: var(--color-primary);
      margin-bottom: 1rem;
    }

    button {
      border: 0;
      cursor: pointer;
      width: 350px;
      height: 60px;
      background: var(--color-primary);
      border-radius: 10px;
      color: #fff;
      font-weight: 600;
      font-size: 18px;
      text-align: center;
    }
    a {
      margin-top: 2rem;
      span {
        cursor: pointer;
        font-size: 18px;
        font-weight: 700;
        color: #a6a6a6;
      }
    }
  }
`;

export const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  color: #707070;
  font-weight: 700;
  font-size: 14px;

  input {
    margin-top: 5px;
    width: 350px;
    height: 80px;
    font-size: 18px;
    border: 2px solid #e9e9e9;
    border-radius: 5px;
    padding: 1rem;
    color: #a6a6a6;
    font-weight: 700;
    ::placeholder {
      color: #a6a6a6;
    }
  }
`;
